import styled from 'styled-components';

export const GaugeWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
`;

export const GaugeSvgContainer = styled.div`
  flex-shrink: 0;
  width: 110px;
  height: 62px;
`;

export const GaugeInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const GaugeCurrentValue = styled.span<{
  $stopped: boolean;
  $color: string;
}>`
  font-size: 2.5rem;
  font-weight: 600;
  letter-spacing: -0.025em;
  line-height: 1;
  color: ${({ $stopped, $color }) =>
    $stopped ? 'var(--allie-color-neutral-40)' : $color};
`;

export const GaugeExpectedText = styled.span`
  font-size: 0.875rem;
  font-weight: 400;
  color: var(--allie-color-neutral-50);
`;
